import { IconDefinition } from '../../types';

const BarChart: IconDefinition = {
  name: 'bar-chart',
  definition: {
    viewBox: '0 0 24 24',
    pathData:
      'M2 5.2C2 5.08954 2.08954 5 2.2 5H3.8C3.91046 5 4 5.08954 4 5.2V17H21.8C21.9105 17 22 17.0895 22 17.2V18.8C22 18.9105 21.9105 19 21.8 19H3.8H2.2C2.08954 19 2 18.9105 2 18.8V17.2V5.2ZM6.4 10C6.17909 10 6 10.1791 6 10.4V11.6C6 11.8209 6.17909 12 6.4 12H13.6C13.8209 12 14 11.8209 14 11.6V10.4C14 10.1791 13.8209 10 13.6 10H6.4ZM6 13.4C6 13.1791 6.17909 13 6.4 13H19.6C19.8209 13 20 13.1791 20 13.4V14.6C20 14.8209 19.8209 15 19.6 15H6.4C6.17909 15 6 14.8209 6 14.6V13.4ZM6.4 7C6.17909 7 6 7.17909 6 7.4V8.6C6 8.82091 6.17909 9 6.4 9H16.6C16.8209 9 17 8.82091 17 8.6V7.4C17 7.17909 16.8209 7 16.6 7H6.4Z'
  }
};

export default BarChart;
